export const ACTIONS = {
  SET_USER: "SET_USER",
  SET_LOADER: "SET_LOADER",
  SET_ROLE: "SET_ROLE",
  SET_STUDENT_PERSONAL: "SET_STUDENT_PERSONAL",
  SET_ERROR: "SET_ERROR"  
}